import React from 'react';
import { TableLegendItem, TableLegendMarker, Container } from './styles';
import {
  FAMILIAS_DA_LEGENDA,
  MARCADORES_DE_TROCA,
  corDaSituacao,
  nomeDaSituacao,
} from 'utils/situacao';

export const TableLegend = () => {
  return (
    <Container>
      {FAMILIAS_DA_LEGENDA.map((familia) => (
        <TableLegendItem key={familia} color={corDaSituacao(familia).solido}>
          <div />
          {nomeDaSituacao(familia)}
        </TableLegendItem>
      ))}
      {MARCADORES_DE_TROCA.map(({ troca, marcador, nome }) => (
        <TableLegendMarker key={troca}>
          <span>{marcador}</span>
          {nome}
        </TableLegendMarker>
      ))}
    </Container>
  );
};
